import SubcategoryPage from '@/components/template/SubcategoryPage';

const KamnitiDodatki = () => {
  const products = [
    {
      title: "Marmornata posoda Pietra",
      imageSrc: "https://images.unsplash.com/photo-1581912492723-688317ba2762?auto=format&fit=crop&q=80",
      url: "/dodatki/kamniti/pietra"
    },
    {
      title: "Marmorni podstavki Eleganza",
      imageSrc: "https://images.unsplash.com/photo-1572207485901-8c64117e6df8?auto=format&fit=crop&q=80",
      url: "/dodatki/kamniti/eleganza"
    },
    {
      title: "Kamnita skleda Natura",
      imageSrc: "https://images.unsplash.com/photo-1618160702438-9b02ab6515c9?auto=format&fit=crop&q=80",
      url: "/dodatki/kamniti/natura"
    },
    {
      title: "Okrasne kamne figure Solido",
      imageSrc: "https://images.unsplash.com/photo-1563585998769-d9ef6bec42e8?auto=format&fit=crop&q=80",
      url: "/dodatki/kamniti/solido"
    }
  ];

  return (
    <SubcategoryPage
      title="Kamniti dodatki"
      description="Luksuzni kamniti dodatki, ki s svojo težo in naravno lepoto prinašajo občutek prestižnosti v vsak prostor."
      heroImage="https://images.unsplash.com/photo-1581912492723-688317ba2762?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default KamnitiDodatki;